import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { AuthUser } from "interfaces/dataInterfaces"

interface Common {
  message?: string
  type?: string
  alertMessage?: string
  alertType?: string
  authUser?: AuthUser | null
}

const initialState: Common = { message: "", type: "", alertMessage: "", alertType: "" }

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setSnackBar: (state, action: PayloadAction<{ message: string; type?: string }>) => {
      state.message = action.payload.message
      state.type = action.payload.type
      state.alertMessage = ""
      state.alertType = ""
    },
    setAlert: (state, action: PayloadAction<{ alertMessage: string; alertType?: string }>) => {
      state.alertMessage = action.payload.alertMessage
      state.alertType = action.payload.alertType
    },
    setUser: (state, action: PayloadAction<AuthUser | null>) => {
      state.authUser = action.payload
    },
  },
})
export const { setSnackBar, setAlert, setUser } = commonSlice.actions

const commonState = state => state.common

export const selectUser = createSelector(commonState, common => common.authUser)

export default commonSlice.reducer
